<div class="d-flex ml-auto align-items-center">
  <!-- CONTENT -->
  <ng-content select="[app-show-details-option-content]"></ng-content>
  <!-- ./CONTENT -->

  <button mdbBtn (click)="onShowDetails()" flat="true" type="button" class="pl-2 pr-0 z-depth-0 m-0">
    <i *ngIf="!showDetails" class="fad fa-caret-circle-down blue-grey-text fa-lg"></i>
    <i *ngIf="showDetails" class="fad fa-caret-circle-up blue-grey-text fa-lg"></i>
  </button>
</div>